const allgetcomreceipt = { data: [], loading: true };
const allcomreceiptTableData = { data: [], loading: true, cache: {} };

export const GetComReceiptRed = (state = allgetcomreceipt, action) => {
  switch (action.type) {
    case "get_allcommissionreceipt":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
export const GetAllComReceiptTableRed = (state = allcomreceiptTableData, action) => {
  switch (action.type) {
    case "get_allComRectabledata":
      return {
        ...state,
        data: action.payload,
        loading: action.loader ?? false,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };

    case "clear_comreceipt_cache":
      return {
        ...state,
        cache: {},
      };

    default:
      return state;
  }
};
